import gql from 'graphql-tag'

export default gql`
subscription OnConversation($userId: ID!) {
  onConversation(userId: $userId) {
    id,
    userId,
    userType,
    user {
      id,
      name,
      avatarId,
      photoFlag,
      email
    },
    opponentId,
    opponentType,
    opponent {
      id,
      name,
      avatarId,
      photoFlag,
      email
    },
    title,
    lastMessageId,
    updatedAt,
    unreads,
    internId
  }
}`



// WEBPACK FOOTER //
// ./src/graphql/chat/subscriptions/on-conversation.subscription.js